import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

/**
 * Isolates a crash in any single admin tab so it never blanks the whole
 * admin portal. Shows a friendly retry panel instead.
 */
export class TabErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        console.error("Admin tab crashed:", error, info);
    }
    render() {
        if (this.state.error) {
            return (
                <div className="rounded-2xl border border-red-200 bg-red-50 p-10 text-center" data-testid="tab-error">
                    <AlertTriangle className="h-10 w-10 text-red-400 mx-auto" />
                    <p className="mt-3 font-display font-black text-lg text-navy">This section hit an error</p>
                    <p className="mt-1 text-sm text-stone-500 break-all">{String(this.state.error?.message || this.state.error)}</p>
                    <button onClick={() => this.setState({ error: null })} data-testid="tab-error-retry"
                        className="mt-4 rounded-full bg-navy text-cream font-bold px-6 py-2.5 text-sm hover:bg-saffron transition-colors inline-flex items-center gap-2">
                        <RefreshCw className="h-4 w-4" /> Try again
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
